import getConfig from 'next/config';
import { DpAnalytics } from '@greatmindsorg/dp-analytics-lib';

const { publicRuntimeConfig } = getConfig();

export const initializeAnalytics = () => {
  DpAnalytics({
    appName: 'login-ui',
    debug: publicRuntimeConfig.NODE_ENV !== 'production',
    googleAnalyticsId: publicRuntimeConfig.GA4_MEASUREMENT_ID,
  }).ready(() => DpAnalytics().reset());
};
